import React from 'react';
import { api } from 'xadmin';

const TagWrap = (props) => {
  const [ { tags, loading }, setState ] = React.useState({ tags: [], loading: false })

  React.useEffect(() => {
    setState({ tags: [], loading: true })
    if(props.nodeId) {
      api({ name: 'core/node/tag' }).fetch('/' + props.nodeId)
        .then(({ json }) => {
          setState({
            tags: json, loading: false
          })
        })
    } else if(props.modelId) {
      api({ name: 'core/model/tag' }).get(props.modelId)
        .then(json => {
          setState({
            tags: json && json.tags, loading: false
          })
        })
    }
  }, [ props.modelId, props.nodeId ])

  return props.children({ tags, loading })
}

export default TagWrap;
